import Chip from "@material-ui/core/esm/Chip";
import Icon from "@material-ui/core/esm/Icon";
import Paper from "@material-ui/core/esm/Paper";
import Box from '@material-ui/core/Box/Box';
import { Info } from 'components/Text';
import React from 'react';
import AccountBalanceOutlined from "@material-ui/icons/esm/AccountBalanceOutlined";
import ChevronRight from "@material-ui/icons/esm/ChevronRight";
import useStyles from './FinancialSecurityDepositDisplayStyles';
import { useTranslation } from 'react-i18next/';
import { INVOICE_DETAILS } from 'routes/invoices/paths';
import { useHistory } from 'react-router-dom';
export default function FinancialSecurityDepositDisplay({
  deposit
}) {
  const {
    depositDisplay,
    depositSection,
    iconCircle,
    seeDetails,
    status
  } = useStyles();
  const {
    t
  } = useTranslation();
  const {
    push
  } = useHistory();
  const amount = new Intl.NumberFormat('nb-NO', {
    maximumFractionDigits: 2
  }).format(deposit.securedAmount ?? 0);
  const currency = deposit.currency === 'NOK' ? 'Kr.' : deposit.currency;
  const statusLabel = deposit.status?.replace(/([a-z])([A-Z])/g, '$1 $2').replace(/^./, value => value.toUpperCase());
  return /*#__PURE__*/React.createElement(Paper, {
    className: depositDisplay,
    elevation: 1
  }, /*#__PURE__*/React.createElement(Box, {
    className: iconCircle
  }, /*#__PURE__*/React.createElement(Icon, null, /*#__PURE__*/React.createElement(AccountBalanceOutlined, null))), /*#__PURE__*/React.createElement(Box, {
    className: depositSection
  }, /*#__PURE__*/React.createElement("b", null, t('financial_security.financial_security_deposit')), /*#__PURE__*/React.createElement(Info, null, t('financial_security.overview_active_deposit'))), /*#__PURE__*/React.createElement(Box, {
    className: depositSection
  }, /*#__PURE__*/React.createElement("b", null, t('financial_security.active_deposit_amount')), /*#__PURE__*/React.createElement(Info, null, `${currency ?? 'Kr.'} ${amount}`)), /*#__PURE__*/React.createElement(Box, {
    className: depositSection
  }, /*#__PURE__*/React.createElement("b", null, "Status"), statusLabel && /*#__PURE__*/React.createElement(Chip, {
    className: status,
    label: statusLabel,
    size: "small"
  })), /*#__PURE__*/React.createElement(Box, {
    className: depositSection
  }, /*#__PURE__*/React.createElement("button", {
    disabled: !deposit.invoiceNumber,
    type: "button",
    "aria-label": "See deposit details",
    className: seeDetails,
    onClick: () => {
      if (deposit.invoiceNumber) push(INVOICE_DETAILS(deposit.invoiceNumber));
    }
  }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("b", null, t('financial_security.see_deposit_details'))), /*#__PURE__*/React.createElement(ChevronRight, null))));
}